import {Unit} from "./unit";
import {bignumber} from "mathjs";

export interface PressureUnit extends Unit {

}

export const PressureUnitPsig: PressureUnit = {
  roundingIncrement: bignumber("1")
}

export const PressureUnitKpa: PressureUnit = {
  roundingIncrement: bignumber("5.0")
}

export const PressureUnitBar: PressureUnit = {
  roundingIncrement: bignumber("0.05")
}
